import {
    BillingProvider,
    DocumentPreviewOverlay,
    DocumentPreviewProvider,
    DocumentSignModal,
    DocumentSignModalProvider,
    DossierDocumentSignProvider,
    DossierDocumentsProvider,
    DossierPrescriberProvider,
    DossierRoutingProvider,
    dossiersBasePath,
    SelectedDossierProvider,
} from '@europrocurement/l2d-modules';
import { Container } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import { ordersBasePath } from '../../../Orders';
import { DetailDossierHeader, DossierBody } from '../../components';

const DetailDossier: React.FunctionComponent = function () {
    const { idDossier } = useParams();

    return (
        <DossierRoutingProvider
            orderBasePath={ordersBasePath}
            dossierBasePath={dossiersBasePath}
        >
            <DocumentPreviewProvider>
                <Container maxWidth="lg">
                    <SelectedDossierProvider>
                        <DocumentSignModalProvider>
                            <DossierDocumentSignProvider>
                                <DossierPrescriberProvider>
                                    <DossierDocumentsProvider
                                        autoload
                                        dossierIds={[idDossier as unknown as string]}
                                    >
                                        <BillingProvider>
                                            <DetailDossierHeader />
                                            <DossierBody />
                                        </BillingProvider>
                                        <DocumentSignModal />
                                    </DossierDocumentsProvider>
                                </DossierPrescriberProvider>
                            </DossierDocumentSignProvider>
                        </DocumentSignModalProvider>
                    </SelectedDossierProvider>
                </Container>
                <DocumentPreviewOverlay />
            </DocumentPreviewProvider>
        </DossierRoutingProvider>
    );
};

export default DetailDossier;
